import React, {useEffect, useState} from "react";
import {FormattedMessage, injectIntl} from "react-intl";
import Text from "@amzn/meridian/text";
import {getCurrentFormattedTime} from "./Util";
import PropTypes from "prop-types";

/**
 * React component for getting the last refresh time in a page
 * using the current locale settings
 * @param deps
 * @param locale
 * @return JSX.Element
 */
const RefreshTimer = ({deps, intl}) => {
    const [latestRefreshTime, setRefreshTime] = useState("");
    useEffect(() => {
        setRefreshTime(getCurrentFormattedTime(intl.locale));
    }, deps);

    return (
        <Text type="b200">
            <FormattedMessage id="common.data_last_updated" defaultMessage="Data last updated"/>: {latestRefreshTime}.
        </Text>
    )
}

RefreshTimer.propTypes = {
    deps: PropTypes.array,
    locale: PropTypes.string,
};

export default injectIntl(RefreshTimer)



// WEBPACK FOOTER //
// ./src/components/util/RefreshTimer.js